module.exports = __webpack_public_path__ + "media/body-condition/cavapoo-skinny-4702e2f9.svg";